import React from 'react';
import { NumberInput, CheckBox } from 'hyperdb-utils';

const DayOfWeekPricesEditor = (props) => {
  const prices = props.prices || [];
  return (
    <table className="table table-striped">
      <thead><tr><th>Day</th><th>Daily Price</th><th>Extra Guest Fee</th></tr></thead>
      <tbody>
      {
        [0, 1, 2, 3, 4, 5, 6].map(indexPrice => {
          const price = props.prices[indexPrice] || {};
          return (
            <tr key={ indexPrice }>
              <td>{ labelDay(indexPrice) }</td>
              <td>
                <NumberInput
                  label={null}
                  name="price"
                  placeholder={ props.defaultPrices.base_price || 0 }
                  value={ price.price }
                  onChange={ handleChangePrice.bind(null, props, indexPrice, 'price') }
                  error={ indexPrice === 0 && !price.price && props.errorBasePrice ? props.errorBasePrice : null }
                />
              </td>
              <td>
              <NumberInput
                label={null}
                name="extra"
                placeholder={ props.defaultPrices.base_extra || 0 }
                value={ price.extra }
                onChange={ handleChangePrice.bind(null, props, indexPrice, 'extra') }
              />
            </td>
          </tr>
          );
        })
      }
      </tbody>
    </table>
  );
};

function labelDay(numberDay) {
  const days = {
    0: 'Monday',
    1: 'Tuesday',
    2: 'Wednesday',
    3: 'Thursday',
    4: 'Friday',
    5: 'Saturday',
    6: 'Sunday',
  };
  return days[numberDay];
}
function handleChangePrice(props, index, attributeName, field) {
  const { name, value } = field;
  const prices = (props.prices || []).slice();
  prices[index] = prices[index] || {};
  prices[index][attributeName] = value;
  prices[index].day_of_week = index + 1;
  props.onChange({ value: prices });
}

DayOfWeekPricesEditor.propTypes = {
  variable_by_day_week: React.PropTypes.bool,
  prices: React.PropTypes.array,
  onClickVariable: React.PropTypes.func,
  onChange: React.PropTypes.func,
  errorBasePrice: React.PropTypes.string,
};

export default DayOfWeekPricesEditor;



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/rental-ruleset/components/RentalRulesetEditor/DayOfWeekPricesEditor.jsx